// extracted by mini-css-extract-plugin
module.exports = {"pageName":"DashboardForAdmin_pageName__29eKF"};